@if (funnelUsername$ | async; as funnelUsername) {
  <p
    class="mt-10 text-center text-4xl font-bold"
    [style.color]="color | contentBuilderColor"
  >
    {{ 'cart-funnel.welcome' | translate }} {{ funnelUsername }}
  </p>
}
<div
  class="flex flex-col gap-14 text-center"
  [class.pt-44]="resolvedTopPadding === 'auto' || resolvedTopPadding === 'xlarge'"
  [class.pt-8]="resolvedTopPadding === 'small'"
  [class.pt-16]="resolvedTopPadding === 'medium'"
  [class.pt-32]="resolvedTopPadding === 'large'"
>
  <p
    class="text-6xl font-bold"
    [style.color]="color | contentBuilderColor"
  >
    {{ title }}
  </p>
  @if (subtitle) {
    <p
      class="text-3xl mb-18"
      [style.color]="color | contentBuilderColor"
    >
      {{ subtitle }}
    </p>
  }
  <app-kiosk-pager-atom
    [color]="color"
    [value]="value"
    [pagerSize]="pagerSize"
    (valueEmitter)="onValueChange($event)"
  ></app-kiosk-pager-atom>
</div>
